import React from 'react';
import './styles.scss';
import useLayoutContext from '../../contexts/layout.context';
import { orderIsPinned } from '../../helpers/functions';
import { getLayoutColor, getPackagingColor } from './functions';

const CardLayout = ({ status, order = {}, children }) => {
  const { permissions, pinnedOrders } = useLayoutContext();
  const { isPackagingRole } = permissions;

  const activeBrands = order.kitchen_ready_brand_ids ?? [];

  const layoutColor = getLayoutColor({ activeBrands, order, permissions, status });
  const packagingColor = getPackagingColor({ status, isPackagingRole, order });
  const pinnedClass = orderIsPinned(pinnedOrders, order) ? 'order-card-pinned' : '';

  return (
    <div
      className={`order-card rounded-lg mx-3 p-6 relative ${layoutColor} ${pinnedClass} `}
      style={packagingColor}>
      {children}
    </div>
  );
};

export default CardLayout;
